import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import OnePagePaperArticleIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/OnePagePaperArticle';
import ShieldWithCrossIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithCross';
import ThreePeopleWithDollarSignIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ThreePeopleWithDollarSign';
import TwoPeopleOneWayArrowIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleOneWayArrow';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'estate-planning-will-understanding-product',
    icon: OnePagePaperArticleIcon,
    title: 'A will',
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Tells your loved ones who should get what when you&#39;re no longer here and names a guardian if you have children under the age <WidowBlock>of 18.</WidowBlock>
      </Typography>
    ),
  },
  {
    id: 'estate-planning-powers-attorney-understanding-product',
    icon: TwoPeopleOneWayArrowIcon,
    title: 'Powers of attorney',
    contentAs: 'div',
    content:
    (<>
      <Typography disableBottomPadding>
        If you&#39;re not able to make decisions about your finances or medical care, this allows someone you&#39;ve chosen to make them <WidowBlock>for you.</WidowBlock>
      </Typography>
    </>),
  },
  {
    id: 'estate-planning-advanced-directives-understanding-product',
    icon: ShieldWithCrossIcon,
    title: <>Advanced directives <WidowBlock>(living will)</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Lets doctors know which treatments, procedures, and medications you do or don&#39;t want to receive if you&#39;re unable to <WidowBlock>tell them.</WidowBlock>
      </Typography>
    ),
  },
  {
    id: 'estate-planning-trusts-understanding-product',
    icon: ThreePeopleWithDollarSignIcon,
    title: 'Trusts (optional)',
    contentAs: 'div',
    content: (
      <>
        <Typography disableBottomPadding>
          Allows a third party to hold assets on your behalf and specify how and when they will pass to <WidowBlock>your beneficiaries.</WidowBlock>
        </Typography>
      </>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='estate-planning'
      backgroundVariant='lightB'
      headingText={<>Here&#39;s what goes into a strong <WidowBlock>estate plan</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
